import React, { useEffect } from "react";
import Typewriter from 'typewriter-effect';
import grr from "../../assets/images/brr.png"
import flash from "../../assets/images/flash.svg"
import { SpiralSpinner, StageSpinner } from "react-spinners-kit";
import { ClipLoader, PropagateLoader, PuffLoader, PulseLoader } from "react-spinners";
import withLayout from "../../layouts/withLayout";
import UserHeader from "../../layouts/common/header";
// import pgbanner from "../../assets/images/page-banner/about-us-01-hero-bg.jpg"
// import pgbanner from "../../assets/images/newok.png"
import pgbanner from "../../assets/images/craft.jpg"




import $ from "jquery"
import UserLayout from "../../layouts/common";


const AboutUs = () => {

    useEffect(() => {
        setTimeout(() => {
            $("#preloader").delay(450).fadeOut('slow');
        }, 2000);
    }, [])

    return (
        <div>
            
            <div id="preloader">
                <div className="">
                    <PulseLoader color="#2075d6" />
                </div>
            </div>

          
<div>
                <div className="page-banner-section section head-bann" style={{ backgroundImage: `url(${pgbanner})`, justifyContent: "center" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-banner-title">
                                    <h1 className="title text-left gilroy-800">About us</h1>
                                    <p className="gilroy-600 text-left text-white" style={{ fontSize: "19px" }}>Exclusive Premium Services</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>



<div className="about-section section section-padding-top-190 section-padding-bottom">
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6 col-md-12 order-lg-1 order-2">
        <div className="about-content mt-sm-50 mt-xs-50">
          {/* <span className="sub-title">Get to know about <strong>MaxCoach</strong></span> */}
                                    <h2 className="title gilroy-700">Learn about our work culture at<span className="gilroy-700"> Callforatech</span></h2>
          <p>
                                        We have been providing quality IT solutions to homes for over 7 years. Our well trained and certified staff have 5-20 years experience in the field and know how to apply real solutions to the function of your personal tech devices and IT needs. We have the best prices around offering to you at all times a Lower Price Than Any Major Advertised Competitor! We Also Come To You at no additional cost saving you hundreds of dollars (major competition charge $100-150 just to show up at your door.) We are the experts, here to service you!
             </p>
        </div>
      </div>
      <div className="col-lg-6 col-md-12 order-lg-1 order-1">
        <div className="about-image">
          <div className="about-image-one">
            <img src={grr} alt="about01" />
          </div>
          <div className="about-image-two">
            {/* <img src={grr} alt="about02" /> */}
          </div>
          {/* Animation Shape Start */}
          <div className="shape shape-1 scene">
            <span data-depth={4}>shape 1</span>
          </div>
          <div className="shape shape-2 scene">
            {/* <span data-depth={4}><img src={grr} alt /></span> */}
          </div>
          <div className="shape shape-3 scene">
            {/* <span data-depth={4}><img src={grr} alt /></span> */}
          </div>
          <div className="shape shape-4 scene">
            {/* <span data-depth={4}><img src={grr} alt /></span> */}
          </div>
          {/* Animation Shape End */}
        </div>
      </div>
    </div>
  </div>
</div>

    










   <div>

  <div className="newsletter-section section section-padding position-relative">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="newsletter-content">
            <h2 className="title">Sign up for our <span>Newsletters</span></h2>
            <p>Enter your email address to register to our newsletter subscription <br className="d-none d-md-block" />delivered on a regular basis! </p>
            <div className="newsletter-form">
              <form action="#">
                <input type="email" placeholder="Your E-mail" />
                <button className="btn btn-primary btn-hover-secondary">Subscribe</button>
              </form>
            </div>
            {/* Animation Shape Start */}
            <div className="shape shape-1 scene">
              <span data-depth={4}>shape 3</span>
            </div>
            <div className="shape shape-2 scene">
              {/* <span data-depth={4}><img src="assets/images/shape-animation/nwesletter-shape-1.png" alt /></span> */}
            </div>
            <div className="shape shape-3 scene">
              {/* <span data-depth={4}><img src="assets/images/shape-animation/nwesletter-shape-2.png" alt /></span> */}
            </div>
            {/* Animation Shape End */}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>

          
        </div>

    )
}

export default withLayout(UserLayout)(AboutUs);